import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    padding: theme.spacing(3),

    '& .appointments-list': {
      '&-container': {
        marginBottom: theme.spacing(3),

        [theme.breakpoints.down('xs')]: {
          marginBottom: theme.spacing(9),
        },
      },
      '&-title': {
        color: theme.palette.text.secondary,
        padding: theme.spacing(3, 0),
        display: 'flex',
      },
      '&-item-empty': {
        display: 'flex',
        backgroundColor: theme.palette.custom.background.area,
        boxShadow: theme.shadows[25],
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
        alignItems: 'center',
        minHeight: theme.spacing(8),
        padding: theme.spacing(2, 3),
        transition: theme.transitions.create(),
        borderRadius: theme.shape.borderRadius,

        '&:hover': {
          boxShadow: theme.shadows[8],
        },
      },
    },
  },
}));

export default styles;
